/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
 

export enum detailLevelEnum {
  DEFAULT = 'Default',
  CRUISE_ITINERARY = 'CruiseItinerary',
  FLIGHT_SEGMENTS = 'FlightSegments',
  PRICE_DETAILS = 'PriceDetails',
}
